// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Ydg-","col":"styles_col__3ssnw","fulfillmentStatus":"styles_fulfillmentStatus__3G7JZ","emailCol":"styles_emailCol__1jwtx"};